<template>
  <v-container class="u-pre-wrap">
    <v-col>
      <v-row justify="center">
        <SubHeader title="PlatJaMからのお知らせ" :loading="loading" />
      </v-row>
      <v-row justify="center">
        <v-col cols="11" xl="8" lg="9" md="10" sm="10">
          <v-list v-if="!loading">
            <template v-if="announcement.length">
              <template v-for="i in announcement">
                <div :key="i.id">
                  <v-card flat>
                    <v-card-subtitle>
                      <b>{{ i.displayDate }}</b>
                    </v-card-subtitle>
                    <v-card-text>
                      {{ i.announcementText }}
                    </v-card-text>
                  </v-card>
                </div>
              </template>
            </template>
            <template v-else>
              <div class="text-center">
                お知らせはありません
              </div>
            </template>
          </v-list>
        </v-col>
      </v-row>

      <v-row justify="center">
        <SubHeader title="受講中講座一覧" :loading="loading" />
      </v-row>
      <v-row justify="space-between">
        <v-col cols="12">
          <v-list v-if="!loading">
            <template v-if="inprogress.length">
              <template v-for="(info, i) in inprogress">
                <div v-if="isSignedIn" :key="i">
                  <!-- 以下のunit-listの表記付近は必要か？ -->
                  <CourseCard :key="i" :to="`${info.card.systemName}/unit-list`" :card="info.card" :course-status="info.status" />
                </div>
              </template>
            </template>
            <template v-else>
              <div class="text-center">
                登録された講座はありません
              </div>
            </template>
          </v-list>
        </v-col>
      </v-row>

      <v-row justify="center">
        <SubHeader title="受講終了講座一覧" :loading="loading" />
      </v-row>
      <v-row justify="space-between">
        <v-col cols="12">
          <v-list v-if="!loading">
            <template v-if="finished.length">
              <template v-for="(info, i) in finished">
                <div v-if="isSignedIn" :key="i">
                  <CourseCard :key="i" :to="`${info.card.systemName}/unit-list`" :card="info.card" :course-status="info.status" :card-type="'finished'" />
                </div>
              </template>
            </template>
            <template v-else>
              <div class="text-center">
                受講終了した講座はありません
              </div>
            </template>
          </v-list>
        </v-col>
      </v-row>

      <v-row justify="center">
        <SubHeader title="修了証発行状況一覧" :loading="loading" />
      </v-row>
      <v-row justify="space-between">
        <v-col cols="12">
          <v-list v-if="!loading">
            <template v-if="passed.length">
              <template v-for="(info, i) in passed">
                <div v-if="isSignedIn" :key="i">
                  <CourseCard :key="i" :to="`${info.card.systemName}/Certification`" :card="info.card" :course-status="info.status" />
                </div>
              </template>
            </template>
            <template v-else>
              <div class="text-center">
                修了証発行済／発行可能な講座はありません
              </div>
            </template>
          </v-list>
        </v-col>
      </v-row>
      <v-row justify="center">
        <SubHeader title="開講中講座一覧" :loading="null" />
      </v-row>
      <v-row justify="space-between">
        <v-col cols="12">
          <v-list-item :href="'https://www.jmooc.jp/'">
            <v-container class="py-0" fluid fill-height>
              <v-row align="center" justify="center">
                <v-col class="text-right" cols="4">
                  <v-avatar width="100" tile>
                    <img :src="require(`@/assets/jmooc/logo.svg`)" width="100" />
                  </v-avatar>
                </v-col>
                <v-col cols="8">
                  <v-card-title class="text-caption text-left" v-text="'JMOOCホームページ（JMOOC提供講座一覧）'" />
                  <v-card-subtitle class="grey--text text-left text-caption" v-text="'PlatJaM以外も含む全ての講座一覧'" />
                </v-col>
              </v-row>
            </v-container>
          </v-list-item>
        </v-col>
      </v-row>
      <v-row justify="space-between">
        <v-col cols="12">
          <v-list-item :href="'https://www.jmooc.jp/science-and-technology/'">
            <v-container class="py-0" fluid fill-height>
              <v-row align="center" justify="center">
                <v-col class="text-right" cols="4">
                  <v-avatar width="100" height="30" tile>
                    <img :src="require(`@/assets/jmooc/kikaku.jpeg`)" width="100" />
                  </v-avatar>
                </v-col>
                <v-col cols="8">
                  <v-card-title class="text-caption text-left" v-text="'JMOOC 理工系・情報系・ビジネス系基礎講座'" />
                  <v-card-subtitle class="grey--text text-left text-caption" v-text="'PlatJaMの講座一覧'" />
                </v-col>
              </v-row>
            </v-container>
          </v-list-item>
        </v-col>
      </v-row>
    </v-col>
  </v-container>
</template>

<script>
import axios from 'axios'
import store from '@/store/store'
import handleApiError from '@/plugins/handleApiError'
import repository from '@/store/repository'
import SubHeader from '@/components/pages/courseList/SubHeader.vue'
import CourseCard from '@/components/pages/courseList/CourseCard.vue'

export default {
  components: {
    SubHeader,
    CourseCard
  },
  data () {
    return {
      loading: false,
      cards: require('@/assets/courseData/courseCards'),
      cardnumbers: [],
      checkresult: [],
      checktype: ['info', 'inProgress', 'finished', 'passed'],
      announcement: [],
      inprogress: [],
      finished: [],
      passed: [],
      isSignedIn: false,
      currentCourse: null
    }
  },
  computed: {},
  async created () {
    const courseId = this.$route.params.courseId
    const courseData = require('@/assets/courseData/courseCards.json')
    this.currentCourse = courseData.find((course) => course.systemName === courseId)
  },
  mounted: async function () {
    this.isSignedIn = repository.isSignedIn()
    if (!this.isSignedIn) {
      this.$router.push({ name: 'SignIn' })
      return
    }

    this.loading = true
    this.announcement = await this.getAnnouncement('all')
    this.inprogress = await this.fetchCourseProgress('inProgress')
    this.finished = await this.fetchCourseProgress('finished')
    this.passed = await this.fetchCourseProgress('passed')
    this.loading = false
  },
  methods: {
    getCorseDataFromId: function (id) {
      return this.cards.find((v) => v.courseId === String(id))
    },

    async getAnnouncement (checktype) {
      const reqUrl = process.env.VUE_APP_GET_ANNOUNCEMENT_URL
      const reqBody = {
        requestType: checktype,
        pjmUserId: String(repository.getPjmUserId()),
        cognitoIdToken: repository.getIdToken(),
        cognitoUsername: store.state.username
      }
      const header = {
        headers: {
          'x-api-key': process.env.VUE_APP_DB_API_KEY,
          Authorization: repository.getAccessToken()
        }
      }
      const res = await axios.post(reqUrl, reqBody, header).catch(handleApiError)
      const resData = res.data || []
      const announcementData = []
      // 最新3件を取得（3件以上存在する場合の例外処理は未対応
      for (let i = 0; i < resData.length; i++) {
        const info = {
          id: i,
          displayDate: resData[i].displayDate,
          announcementText: resData[i].announcementText
        }
        announcementData.push(info)
      }
      return announcementData
    },

    async fetchCourseProgress (checktype) {
      // API通信部分
      const reqUrl = process.env.VUE_APP_MYPAGE_USER_API_URL
      const reqBody = {
        checkType: checktype,
        pjmUserId: String(repository.getPjmUserId()),
        cognitoIdToken: repository.getIdToken(),
        cognitoUsername: store.state.username
      }
      const header = {
        headers: {
          'x-api-key': process.env.VUE_APP_DB_API_KEY,
          Authorization: repository.getAccessToken()
        }
      }
      const res = await axios.post(reqUrl, reqBody, header).catch(handleApiError)
      const resData = res.data.checkResult || []

      // checktypeに該当した講座情報を格納する
      const courses = []
      for (let i = 0; i < resData.length; i++) {
        let status
        if (resData[i]['certificated-issued']) {
          status = 'certificated-issued'
        } else if (resData[i]['certificated-unissued']) {
          status = 'certificated-unissued'
        } else if (resData[i].passed) {
          status = 'passed'
        } else if (resData[i]['failed-finished']) {
          status = 'failed-finished'
        } else if (resData[i]['failed-unfinished']) {
          status = 'failed-unfinished'
        } else if (resData[i].unpassed) {
          status = 'unpassed'
        }
        const info = { card: this.getCorseDataFromId(resData[i].courseId), status: status }
        courses.push(info)
      }
      return courses
    }
  }
}
</script>
